import styled from "styled-components";

export const TimeSheetStatus = ({ status }) => {
  return (
    <TimeSheetStatusWrap>
      {status === "pending" && <span className="status pending">Pending</span>}
      {status === "approved" && (
        <span className="status approved">Approved</span>
      )}
      {status === "declined" && (
        <span className="status declined">Declined</span>
      )}
      {status === "withdrawn" && (
        <span className="status withdrawn">Withdrawn</span>
      )}
    </TimeSheetStatusWrap>
  );
};

const TimeSheetStatusWrap = styled.div`
  .status {
    font-size: 14px;
    font-weight: 500;
  }

  .pending {
    color: #774b00;
  }
  .approved {
    color: #32b900;
  }
  .declined {
    color: #d93025;
  }
  .withdrawn {
    color: #ff7676;
  }
`;
